module.exports = __webpack_public_path__ + "static/media/CriptoPagos.728b7a5b.svg";